import { lazy, Suspense } from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';
import { useFlag } from '@unleash/proxy-client-react';

import { selectUser } from 'store';

import Loader from 'shared/Loader';

import { useAppSelector } from 'hooks';
import { FeatureFlag } from 'utils/enums';
import { lazyRetry } from 'utils/lazy';
import { PathName } from './paths';

import { SignupRouter } from './Router';

const SignUp = lazy(() => lazyRetry(() => import('containers/SignUp')));
const Join = lazy(() => lazyRetry(() => import('containers/Join')));
const UnsupportedAge = lazy(() => lazyRetry(() => import('pages/UnsupportedAge')));

const JoinGuard = () => {
  const { accessToken } = useAppSelector(selectUser);
  const isDisabledInternalSignups = useFlag(FeatureFlag.DisableInternalSignups);

  if (!accessToken && isDisabledInternalSignups) {
    return <Navigate to={PathName.CreateAppointment} replace />;
  }

  return (
    <Suspense fallback={<Loader isVisible />}>
      <Join />
    </Suspense>
  );
};

const SignUpGuard = () => {
  const { accessToken } = useAppSelector(selectUser);
  const isDisabledInternalSignups = useFlag(FeatureFlag.DisableInternalSignups);
  const location = useLocation();

  if (accessToken) {
    return <Navigate to={`${PathName.Home + location.search}`} />;
  }

  if (isDisabledInternalSignups) {
    return <Navigate to={PathName.CreateAppointment} replace />;
  }

  return (
    <Suspense fallback={<Loader isVisible />}>
      <SignUp />
    </Suspense>
  );
};

export const getSignupRoutes = () => (
  <>
    <Route path={PathName.Join} element={<JoinGuard />} />
    <Route element={<SignUpGuard />} path={`${PathName.SignUp}/:plan/:flow/:stepName`} />
    <Route element={<SignupRouter />} path={`${PathName.SignUp}/:plan/:flow`} />
    <Route element={<SignupRouter />} path={`${PathName.SignUp}/:plan`} />
    <Route element={<SignupRouter />} path={`${PathName.SignUp}`} />
    <Route element={<UnsupportedAge />} path={PathName.UnsupportedAge} />
  </>
);
